import React from 'react';

interface ProcessStepProps {
    number: string;
    title: string;
    description: string | null | undefined;
    icon: React.ReactNode;
    isLast?: boolean;
}

/**
 * Función que detecta URLs en una cadena de texto y las convierte en elementos <a> de React.
 */
const linkify = (text: string) => {
    if (!text) return text;
    
    // Regex robusta para detectar protocolos http/https o dominios que empiecen por www.
    const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+)/gi;
    const parts = text.split(urlRegex);

    return parts.map((part, i) => {
        if (part.match(urlRegex)) {
            const href = part.toLowerCase().startsWith('http') ? part : `https://${part}`;
            return (
                <a 
                    key={i} 
                    href={href} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="text-sky-600 hover:underline font-bold break-all transition-colors"
                >
                    {part}
                </a>
            );
        }
        return part;
    });
};

export const ProcessStep: React.FC<ProcessStepProps> = ({ number, title, description, icon, isLast }) => {
    // Si la descripción es nula o vacía, no mostramos el paso
    if (!description || description.trim() === '') return null;

    return (
        <div className="flex gap-6 animate-fade-in-down">
            <div className="flex flex-col items-center">
                <div className="w-12 h-12 rounded-2xl bg-sky-600 text-white flex items-center justify-center shadow-lg shadow-sky-100 z-10">
                    {icon}
                </div>
                {!isLast && <div className="w-0.5 h-full bg-sky-100 -my-2"></div>}
            </div>
            <div className="pb-12">
                <div className="flex items-center gap-3 mb-2">
                    <span className="text-[10px] font-black text-sky-500 uppercase tracking-[0.2em]">Etapa {number}</span>
                </div>
                <h3 className="text-xl font-black text-gray-800 uppercase tracking-tight mb-2">{title}</h3>
                <p className="text-gray-600 leading-relaxed max-w-lg whitespace-pre-wrap font-normal">
                    {linkify(description)}
                </p>
            </div>
        </div>
    );
};